import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        paginationContainer: {
            width: '100%',
            display: 'flex',
            justifyContent: 'right',
            paddingTop: theme.spacing(1),
        },
    }
})
